import { useState } from 'react';
import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '../firebase';
import './Login.css';

export default function Login({ onLoginSuccess }) {
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleGoogleSignIn = async () => {
        setError('');
        setIsLoading(true);

        try {
            const result = await signInWithPopup(auth, googleProvider);
            onLoginSuccess(result.user);
        } catch (err) {
            console.error(err);
            if (err.code === 'auth/popup-closed-by-user') {
                setError('Sign-in popup was closed. Please try again.');
            } else {
                setError('Failed to sign in with Google. Please try again.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-header">
                <span className="login-emoji">🎉</span>
                <div className="title-wrapper">
                    <h1>Revlry</h1>
                    <span className="beta-badge">Beta</span>
                </div>
                <p>Sign in to start planning your next event!</p>
            </div>

            <div className="login-card">
                <button
                    onClick={handleGoogleSignIn}
                    className="google-btn"
                    disabled={isLoading}
                >
                    <img
                        src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                        alt="Google"
                        className="google-icon"
                    />
                    <span>{isLoading ? 'Signing in...' : 'Sign in with Google'}</span>
                </button>

                {error && <p className="error-message">{error}</p>}
            </div>

            <p className="login-footer">
                Fast, secure, and no passwords to remember.
            </p>
        </div>
    );
}
